import { mode as viemMode } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const mode = {
  displayName: 'Mode',
  runtime: 'evm',
  viemChain: viemMode,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'mode' },
    qnStreams: {
      networkKey: 'mode-mainnet',
    },
    pimlico: { chainSlug: 'mode' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
